import { formatDurationFromSeconds } from 'src/app/shared/utils/session-runtime';

/** Format decimal hours as `h m s` using exact seconds (no 0.1h rounding). */
export function formatDurationHms(hours: number | null | undefined): string {
  if (hours == null || Number.isNaN(Number(hours))) {
    return '—';
  }
  return formatDurationFromSeconds(Math.round(Number(hours) * 3600));
}

export function formatReportDuration(
  seconds: number | null | undefined,
  hoursFallback?: number | null,
): string {
  if (seconds != null && !Number.isNaN(Number(seconds))) {
    return formatDurationFromSeconds(seconds);
  }
  return formatDurationHms(hoursFallback);
}
